import { mountStoreDevtool } from 'simple-zustand-devtools';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';


type PersonalInfoState = {
	firstName: string;
	lastName: string;
	email: string;
	phone: string;
	dateOfBirth: string | Date;
	salesforceGuid: string | null;
	salesforceAccountId: string | null;
	leadSegment20: string | null; // @deprecated
	salesforceS20: number | null;
	salesforceTier: string | null;
};

type PersonalInfoActions = {
	setFirstName: (firstName: string) => void;
	setLastName: (lastName: string) => void;
	setEmail: (email: string) => void;
	setPhone: (phone: string) => void;
	setDateOfBirth: (dateOfBirth: string) => void;
	setSalesforceGuid: (id: string) => void;
	setSalesforceAccountId: (id: string) => void;
	setLeadSegment20: (score: string) => void;
	setSalesforceS20: (score: number) => void;
	setSalesforceTier: (score: string) => void;
  clear: () => void;
};

type AddressState = {
	address: string;
	zipCode: string;
	city: string;
	state: string;
};

type AddressActions = {
	setAddress: (address: string) => void;
	setZipCode: (zipCode: string) => void;
	setCity: (city: string) => void;
	setState: (state: string) => void;
};

type LeadState = {
	leadId: string;
};

type LeadActions = {
	setLeadId: (leadId: string) => void;
};

type State = PersonalInfoState & AddressState & LeadState;
type Actions = PersonalInfoActions & AddressActions & LeadActions;

const usePatientInformationStore = create<State & Actions>()(
	persist(
		(set) => ({
			salesforceS20: null,
			setSalesforceS20: (salesforceS20) => set({ salesforceS20 }),
			salesforceTier: null,
			setSalesforceTier: (salesforceTier) => set({ salesforceTier }),
			firstName: '',
			setFirstName: (firstName) => set({ firstName }),
			lastName: '',
			setLastName: (lastName) => set({ lastName }),
			email: '',
			setEmail: (email) => set({ email }),
			phone: '',
			setPhone: (phone) => set({ phone }),
			dateOfBirth: '',
			setDateOfBirth: (dateOfBirth: string) => {
				set({ dateOfBirth });
			},
			salesforceGuid: null,
			setSalesforceGuid: (salesforceGuid: string) => set({ salesforceGuid }),
			salesforceAccountId: null,
			setSalesforceAccountId: (salesforceAccountId: string) => set({ salesforceAccountId }),
			leadSegment20: null,
			setLeadSegment20: (leadSegment20: string) => set({ leadSegment20 }),
			address: '',
			setAddress: (address) => set({ address }),
			zipCode: '',
			setZipCode: (zipCode) => set({ zipCode }),
			city: '',
			setCity: (city) => set({ city }),
			state: '',
			setState: (state) => set({ state }),
			leadId: '',
			setLeadId: (leadId: string) => set({ leadId }),

			clear: () =>
				set({
					firstName: '',
					lastName: '',
					email: '',
					phone: '',
					dateOfBirth: '',
					address: '',
					zipCode: '',
					city: '',
					state: '',
					leadId: '',
				}),
		}),
		{
			name: 'patient-information-store',
			partialize: (state) => ({
				firstName: state.firstName,
				lastName: state.lastName,
				email: state.email,
				phone: state.phone,
				dateOfBirth: state.dateOfBirth,
				address: state.address,
				zipCode: state.zipCode,
				city: state.city,
				state: state.state,
				leadId: state.leadId,
			}),
		}
	)
);

if (process.env.NODE_ENV === 'development') {
	mountStoreDevtool('usePatientInformationStore', usePatientInformationStore);
}

export default usePatientInformationStore;
